import Styles from './styles.module.css';
import React from 'react';
import { MdError } from 'react-icons/md';

type RecruitExaminationItemProps = {
  message: string;
};

const PartsError: React.FC<RecruitExaminationItemProps> = ({ message }) => {

  return (
    <>
    <div className={Styles.box}>
      <div>
        <MdError className={Styles.box_icon} />
        <p>エラーメッセージ</p>
      </div>
      <h4>{message}</h4>
    </div>
    </>
  );
}

export default PartsError;
